import updatePromos from './update-promos';
import updateCartItems from './update-cart';
import updateAdditionalItems from './update-additional-items';
import { setRadioButtonsProducts, updateItemQuantity } from './helpers';
import { fetchData, postData, deleteData } from './fetch';
import updateCartSlider from './update-cart-slider';
// import { get } from 'http';

window.addEventListener('load', () => {
  const productList = document.querySelector('.products-wrapper');
  const cartBottom = document.querySelector('.cart-bottom');
  const orderWrapper = document.querySelector('.order-wrapper');
  const cartPromocodeWrapper = document.querySelector(
    '.cart-promocode-wrapper',
  );
  const confirmDeleteProductPopup = document.querySelector(
    '.confirm-remove-product-popup',
  );
  const confirmButton = document.querySelector(
    '.confirm-remove-product-popup .confirm-button',
  );
  const deleteLoading = document.querySelector(
    '.confirm-remove-product-popup .delete-loading',
  );
  const recommendationWrapper = document.querySelector(
    '.recommendation-products',
  );
  const giftsWrapper = document.querySelector(
    '.gifts-products',
  );
  const additionalProductsList = document.querySelector(
    '.additional-products-list',
  );
  const additionalProductsWrapper = document.querySelector(
    '.additional-products',
  );
  const promocodeForm = document.querySelector('.cart-promocode-form');
  const promocodeInput = document.querySelector(
    '.promocode-input-wrapper input',
  );
  const promocodeInputWrapper = document.querySelector('.promocode-input');
  const promocodeDescription = document.querySelector('.promo-description');
  const submitButton = document.querySelector('.submit-button');
  const promocodeError = document.querySelector('.promocode-error');
  const recommendationsSwiper = document.querySelector(
    '.recommendations-swiper',
  );
  const giftsSwiper = document.querySelector(
    '.gifts-swiper',
  );
  const promocodeSubmitBtn = document.querySelector('.promocode-submit');
  const promoNotificationWrapper = document.querySelector(
    '.promo-notification-wrapper',
  );
  const removePromoBtn = document.querySelector('.remove-promo');
  const promocodeInputPlaceholder = document.querySelector('.placeholder');
  const promoErrorText = document.querySelector('.promo-error');
  const promoSubmitWrapper = document.querySelector(
    '.cart-promocode-form .submit-wrapper',
  );
  const promoCancelWithProductsBtn = document.querySelector(
    '.cart-promocode-form .cancel-promo-with-products',
  );
  const promotionProducts = document.querySelector(
    '.cart-promocode-form .promotion-products',
  );
  const promotionProductsList = document.querySelector(
    '.cart-promocode-form .promotion-products-list',
  );
  const promoApplyWithProducts = document.querySelector(
    '.cart-promocode-form .apply-promo-with-products',
  );

  const cookies = document.cookie.split(';');
  const menuTypeCookie = cookies.find((cookie) => cookie.includes('menuType'));

  let menuType = 'portal';
  let deliveryPrice = 0;

  if (menuTypeCookie) {
    const menuTypeArray = menuTypeCookie.split('=');
    menuType = menuTypeArray[1];
  }

  let recommendationsSlider;
  let giftsSlider;

  const options = {
    slidesPerView: 1,
    spaceBetween: 9,
    loop: false,
    breakpoints: {
      585: {
        slidesPerView: 2,
      },
      980: {
        slidesPerView: 1.4,
      },
      1035: {
        slidesPerView: 1.6,
      },
      1125: {
        slidesPerView: 1.8,
      },
      1200: {
        slidesPerView: 2.1,
      },
      1230: {
        slidesPerView: 2.2,
      },
      1265: {
        slidesPerView: 2.3,
      },
      1320: {
        slidesPerView: 2.4,
      },
    },
    pagination: {
      clickable: true,
      dynamicBullets: true,
    },
  };

  const recommendationsSwiperOptions = { ...options,
    navigation: {
      nextEl: '.swiper-button-next-recommendations',
      prevEl: '.swiper-button-prev-recommendations',
    },
    pagination: {
      ...options.pagination,
      el: '.swiper-pagination-recommendations'
    }
  }
  const giftsSwiperOptions = { ...options,
    navigation: {
      nextEl: '.swiper-button-next-gifts',
      prevEl: '.swiper-button-prev-gifts',
    },
    pagination: {
      ...options.pagination,
      el: '.swiper-pagination-gifts'
    }
  }

  if (recommendationsSwiper) {
    recommendationsSlider = new Swiper('.recommendations-swiper', recommendationsSwiperOptions);
  }

  if (giftsSwiper) {
    giftsSlider = new Swiper('.gifts-swiper', giftsSwiperOptions);
  }

  const rerenderCart = (json, code, slideIndex) => {
    updateCartItems(json.data, json.data.additional);

    if (json.data.recommendations) {
      updateCartSlider(
        json.data.recommendations,
        recommendationWrapper,
        recommendationsSlider,
        slideIndex,
        'recommendations-swiper',
        'recommendation-card'
      );
    } else {
      recommendationWrapper.classList.add('hidden');
    }

    if (json.data.gifts) {
      updateCartSlider(
        json.data.gifts,
        giftsWrapper,
        giftsSlider,
        slideIndex,
        'gifts-swiper',
        'gifts-card',
        true
      );
    } else {
      giftsWrapper.classList.add('hidden');
    }


    if (json.data.additional) {
      updateAdditionalItems(json.data.additional, json.data.cartItems);
    } else {
      additionalProductsWrapper.classList.add('hidden');
    }

    if (json.data.promos) {
      updatePromos(json.data.promos, code);
    }
  };

  const addItemToCart = async (body, slideIndex) => {
    const response = await postData("/cart", body);

    if (response) {
      rerenderCart(response, null, slideIndex);
    }
  };

  const handleClickSliderWrapper = (e) => {
    if (e.target.classList.contains('add-button')) {
      e.preventDefault();

      let slideIndex;
      const parentElement = e.target.closest('.cart-slider-card')

      if (parentElement) {
        const slideWrapper = parentElement.closest('.swiper-slide');
        const isGift = parentElement.closest('.gift-slide');

        const { id } = parentElement.dataset;

        const body = {
          id,
          quantity: 1,
          gift: isGift ? true : false
        };

        if (slideWrapper) {
          slideIndex = slideWrapper.dataset.index;
        }

        addItemToCart(body, slideIndex);
        e.target.classList.add('loading');

        if (submitButton) {
          submitButton.classList.add('disabled');
          submitButton.innerHTML = 'Загрузка...';
        }
      }
    }
  }

  if (recommendationWrapper) {
    recommendationWrapper.addEventListener('click', handleClickSliderWrapper);
  }

  if (giftsWrapper) {
    giftsWrapper.addEventListener('click', handleClickSliderWrapper);
  }

  let additionalQuantityTimeout;

  if (additionalProductsList) {
    additionalProductsList.addEventListener('click', async (e) => {
      const parentElement = e.target.closest('.additional-item');

      if (parentElement) {
        const countInput = parentElement.querySelector('.count-input');
        const priceField = parentElement.querySelector(
          '.addition-product-price span',
        );
        const priceWrapper = parentElement.querySelector(
          '.addition-product-price',
        );
        const buttonPlus = parentElement.querySelector('.plus');
        const countButton = parentElement.querySelector('.count-button');
        const productId = parentElement.dataset.id;

        const itemPrice = parseInt(parentElement.dataset.price, 10);

        let body;

        if (e.target.classList.contains('add-additional')) {
          e.preventDefault();

          e.target.textContent = 'Загрузка...';
          e.target.setAttribute('disabled', 'disabled');

          body = {
            id: productId,
            quantity: 1,
          };

          addItemToCart(body);

          if (submitButton) {
            submitButton.classList.add('disabled');
            submitButton.innerHTML = 'Загрузка...';
          }
        }

        if (e.target.classList.contains('plus')) {
          const countWrapper = e.target.closest('.count-button');
          let countValue = parseInt(countInput.value, 10);

          body = {
            productId,
          };

          clearTimeout(additionalQuantityTimeout);

          if (countValue <= 99) {
            countValue += 1;
            countInput.value = countValue;

            body.quantity = countInput.value;

            if (priceField) {
              priceField.textContent = (itemPrice * countValue) / 100;
            }

            if (submitButton) {
              submitButton.classList.add('disabled');
              submitButton.innerHTML = 'Загрузка...';
            }

            if (countValue === 99) {
              e.target.classList.add('disabled');
            }

            additionalQuantityTimeout = setTimeout(() => {
              countWrapper.classList.add('disabled');
              updateItemQuantity({
                body,
                method: 'PUT',
                menuType,
                wrapper: countWrapper,
                recommendationWrapper,
                slider: recommendationsSlider,
                additionalProductsWrapper,
                giftsWrapper,
                giftsSlider,
              });
            }, 300);
          }
        }

        if (e.target.classList.contains('minus')) {
          const countWrapper = e.target.closest('.count-button');
          let countValue = parseInt(countInput.value, 10);

          body = {
            productId,
          };

          clearTimeout(additionalQuantityTimeout);

          if (countValue > 0) {
            countValue -= 1;

            countInput.value = countValue;
            body.quantity = countInput.value;

            if (priceField) {
              priceField.textContent = (itemPrice * countValue) / 100;
            }

            if (submitButton) {
              submitButton.classList.add('disabled');
              submitButton.innerHTML = 'Загрузка...';
            }

            if (countValue < 99 && buttonPlus.classList.contains('disabled')) {
              buttonPlus.classList.remove('disabled');
            }

            if (countValue === 0) {
              if (countButton) {
                countButton.textContent = 'Загрузка...';
                countButton.classList.add('loading');
              }

              if (priceWrapper) {
                priceWrapper.style.display = 'none';
              }

              const response = await deleteData("/cart", body);

              if (response) {
                if (response.data.cartItems.length) {
                  rerenderCart(response);
                } else {
                  removeCart();
                }

                if (confirmDeleteProductPopup) {
                  confirmDeleteProductPopup.classList.remove('active');
                }
              }
            } else {
              additionalQuantityTimeout = setTimeout(() => {
                countWrapper.classList.add('disabled');
                updateItemQuantity({
                  body,
                  method: 'PUT',
                  menuType,
                  wrapper: countWrapper,
                  recommendationWrapper,
                  slider: recommendationsSlider,
                  additionalProductsWrapper,
                  giftsWrapper,
                  giftsSlider,
                });
              }, 300);
            }
          }
        }
      }
    });
  }

  const removeCart = async () => {
    const response = await deleteData("/cart/remove", null);

    if (response && response === 200) {
      const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

      if (formValuesFromSessionStorage) {
        sessionStorage.removeItem('formValues');
      }

      if (orderWrapper) {
        orderWrapper.remove();
      }

      if (confirmDeleteProductPopup) {
        confirmDeleteProductPopup.classList.remove('active');
      }

      if (deleteLoading) {
        deleteLoading.classList.remove('visible');
      }

      if (cartPromocodeWrapper) {
        cartPromocodeWrapper.remove();
      }

      if (cartBottom) {
        const { free } = cartBottom.dataset;
        const emptyImage = cartBottom.dataset.empty;

        cartBottom.classList.add('empty-cart');

        cartBottom.innerHTML = `<img src="${emptyImage}" class="empty-cart-image" alt="Корзина пуста" />
        <div class="empty-cart-text italic base-text">
          Добавьте товар в корзину
          <span>Бесплатная доставка от ${free} ₽</span>
        </div>
        <a href="/catalog" class="catalog-link base-text pseudo-button bold">Перейти в меню</a>`;
      }
    }
  };

  let cartTimeout;

  if (confirmButton) {
    confirmButton.addEventListener('click', async () => {
      const productId = confirmButton.dataset.id;

      const body = {
        productId,
      };

      if (deleteLoading) {
        deleteLoading.classList.add('visible');
      }

      let response = await deleteData("/cart", body);
      response = { data: await fetchData('/cart') };
     

      if (response) {
        const filteredCartItems = response.data.cartItems.filter((item) =>
          response.data.additional.every(
            (sauce) => sauce.id !== item.productId,
          ),
        );

        if (filteredCartItems.length) {
          rerenderCart(response);

          if (confirmDeleteProductPopup) {
            confirmDeleteProductPopup.classList.remove('active');
          }

          if (deleteLoading) {
            deleteLoading.classList.remove('visible');
          }
        } else {
          removeCart();
        }
      }
    });
  }

  if (productList) {
    productList.addEventListener('click', (e) => {
      const parentElement = e.target.closest('.cart-product-item');

      if (parentElement) {
        const priceField = parentElement.querySelectorAll(
          '.product-price span',
        );
        const productId = parentElement.dataset.id;

        const body = {
          productId,
        };

        const itemPrice = parseInt(parentElement.dataset.price, 10);

        if (e.target.classList.contains('plus')) {
          const countWrapper = e.target.closest('.count-button');
          const countInput = countWrapper.querySelector('.count-input');
          const buttonMinus = countWrapper.querySelector('.minus');
          const buttonPlus = countWrapper.querySelector('.plus');
          let countValue = parseInt(countInput.value, 10);

          clearTimeout(cartTimeout);

          if (countValue <= 99) {
            countValue += 1;
            countInput.value = countValue;

            body.quantity = countInput.value;

            if (priceField) {
              [].forEach.call(priceField, (field) => {
                field.innerHTML = `<span>${
                  (itemPrice * countValue) / 100
                }</span>`;
              });
            }

            if (countValue > 1) {
              buttonMinus.classList.remove('disabled');
            }

            if (countValue === 99) {
              buttonPlus.classList.add('disabled');
            }

            if (submitButton) {
              submitButton.classList.add('disabled');
              submitButton.innerHTML = 'Загрузка...';
            }

            cartTimeout = setTimeout(() => {
              countWrapper.classList.add('disabled');
              updateItemQuantity({
                body,
                method: 'PUT',
                menuType,
                wrapper: countWrapper,
                recommendationWrapper,
                slider: recommendationsSlider,
                additionalProductsWrapper,
                giftsWrapper,
                giftsSlider,
              });
            }, 300);
          }
        }

        if (e.target.classList.contains('minus')) {
          const countWrapper = e.target.closest('.count-button');
          const countInput = countWrapper.querySelector('.count-input');
          const buttonMinus = countWrapper.querySelector('.minus');
          const buttonPlus = countWrapper.querySelector('.plus');
          let countValue = parseInt(countInput.value, 10);

          clearTimeout(cartTimeout);

          if (countValue > 1) {
            countValue -= 1;

            countInput.value = countValue;
            body.quantity = countInput.value;

            if (priceField) {
              [].forEach.call(priceField, (field) => {
                field.innerHTML = `<span>${
                  (itemPrice * countValue) / 100
                }</span>`;
              });
            }

            if (submitButton) {
              submitButton.classList.add('disabled');
              submitButton.innerHTML = 'Загрузка...';
            }

            cartTimeout = setTimeout(() => {
              countWrapper.classList.add('disabled');
              updateItemQuantity({
                body,
                method: 'PUT',
                menuType,
                wrapper: countWrapper,
                recommendationWrapper,
                slider: recommendationsSlider,
                additionalProductsWrapper,
                giftsWrapper,
                giftsSlider,
              });
            }, 300);
          }

          if (countValue === 1) {
            buttonMinus.classList.add('disabled');
          }

          if (countValue < 99 && buttonPlus.classList.contains('disabled')) {
            buttonPlus.classList.remove('disabled');
          }
        }

        if (e.target.classList.contains('delete-item')) {
          const productName = e.target.dataset.name;
          const productParentName = e.target.dataset.parentname;
          const productId = e.target.dataset.id;

          if (confirmDeleteProductPopup) {
            confirmDeleteProductPopup.classList.add('active');
            const confirmText = confirmDeleteProductPopup.querySelector(
              '.confirm-text',
            );

            if (confirmButton) {
              confirmButton.dataset.id = productId;
            }

            if (confirmText) {
              let confirmString = productName;

              if (productParentName) {
                confirmString = `${productParentName}, ${productName}`;
              }

              confirmText.textContent = confirmString;
            }
          }
        }
      }
    });
  }

  if (promoNotificationWrapper) {
    promoNotificationWrapper.addEventListener('click', (e) => {
      if (e.target.classList.contains('cancel-promo')) {
        e.target.addEventListener('click', async () => {
          const { code } = e.target.dataset;
          if (submitButton) {
            submitButton.classList.add('disabled');
            submitButton.innerHTML = 'Загрузка...';
          }

          e.target.setAttribute('disabled', 'disabled');
          e.target.textContent = 'Загрузка...';

          const response = await deleteData(`/cart/promo/${code}`, null);

          if (response) {
            if (response.errors) {
              if (submitButton) {
                const { discount, total } = submitButton.dataset;

                submitButton.classList.remove('disabled');
                submitButton.innerHTML = `Оформить за <span data-discount="${discount}">${total}</span> ₽`;
              }

              e.target.removeAttribute('disabled');
              e.target.textContent = 'Отменить';
            } else {
              rerenderCart(response);
            }
          }
        });
      }
    });
  }

  if (removePromoBtn) {
    removePromoBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      const { code } = removePromoBtn.dataset;

      removePromoBtn.setAttribute('disabled', 'disabled');
      removePromoBtn.textContent = 'Загрузка...';

      let response = await deleteData(`/cart/promo/${code}`, null);
      response = {data: await fetchData('/cart')};
      

      if (response) {
        if (response.errors) {
          removePromoBtn.removeAttribute('disabled');
          removePromoBtn.textContent = 'Отменить';
        } else {
          removePromoBtn.removeAttribute('disabled');
          removePromoBtn.textContent = 'Отменить';

          if (promocodeInputWrapper) {
            promocodeInputWrapper.classList.remove('error', 'valid');
          }

          if (promocodeInputPlaceholder) {
            promocodeInputPlaceholder.textContent = 'Введите промокод';
          }

          if (promocodeSubmitBtn) {
            promocodeSubmitBtn.removeAttribute('disabled');
            promocodeSubmitBtn.value = 'Применить';
            promocodeSubmitBtn.classList.remove('hidden');
          }

          if (promoErrorText) {
            promoErrorText.classList.remove('visible', 'green-color');
          }

          if (removePromoBtn) {
            removePromoBtn.classList.remove('visible');
            promocodeSubmitBtn.removeAttribute('disabled');
            promocodeSubmitBtn.textContent = 'Отменить';
            removePromoBtn.dataset.code = '';
          }

          if(promocodeInput) {
            promocodeInput.removeAttribute("disabled");
          }

          if (promocodeInput) {
            promocodeInput.value = '';
          }

          if (promocodeDescription) {
            promocodeDescription.classList.remove('visible');
          }

          rerenderCart(response);
        }
      }
    });
  }

  const postCartPromo = async (body) => {
    const response = await postData("/cart/promo", body);

    if (response) {
      if (submitButton) {
        const { discount, total } = submitButton.dataset;

        submitButton.classList.remove('disabled');
        submitButton.innerHTML = `Оформить за <span data-discount="${discount}">${total}</span> ₽`;
      }

      rerenderCart(response, body.promo);
    }
  };

  if (promocodeForm) {
    promocodeForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const placeholder = promocodeForm && promocodeForm.querySelector('.placeholder');
      const { value } = promocodeInput;

      if (submitButton) {
        submitButton.classList.add('disabled');
        submitButton.innerHTML = 'Загрузка...';
      }

      if (promocodeSubmitBtn) {
        promocodeSubmitBtn.setAttribute('disabled', 'disabled');
        promocodeSubmitBtn.value = 'Загрузка...';
      }

      if (placeholder) {
        placeholder.textContent = 'Введите промокод';
      }

      if (promocodeInputWrapper) {
        promocodeInputWrapper.classList.remove('error');
      }

      const response = await fetchData(`/promos/vouchers/${value.trim()}`);

      if (response) {
        if (response.statusCode === 400) {
          if (placeholder) {
            placeholder.textContent = 'неверный промокод';
          }

          if (promocodeInputWrapper) {
            promocodeInputWrapper.classList.add('error');
          }

          if (promocodeSubmitBtn) {
            promocodeSubmitBtn.removeAttribute('disabled');
            promocodeSubmitBtn.value = 'Применить';
          }

          if (submitButton) {
            const { discount, total } = submitButton.dataset;

            submitButton.classList.remove('disabled');
            submitButton.innerHTML = `Оформить за <span data-discount="${discount}">${total}</span> ₽`;
          }
        } else {
          if (response.statusCode === 200) {
            promocodeError.classList.remove('visible');

            if (submitButton) {
              const { discount, total } = submitButton.dataset;

              submitButton.classList.remove('disabled');
              submitButton.innerHTML = `Оформить за <span data-discount="${discount}">${total}</span> ₽`;
            }

            if (promocodeSubmitBtn) {
              promocodeSubmitBtn.removeAttribute('disabled');
              promocodeSubmitBtn.value = 'Применить';
              promocodeSubmitBtn.classList.add('hidden');
            }

            if(promocodeInput) {
              promocodeInput.setAttribute("disabled", "disabled");
            }

            if (removePromoBtn) {
              removePromoBtn.classList.add('visible');
              removePromoBtn.dataset.code = value;
            }

            updateCartItems(response.data, response.data.additional);

            if (response.data.recommendations) {
              updateCartSlider(
                response.data.recommendations,
                recommendationWrapper,
                recommendationsSlider,
                undefined,
                'recommendations-swiper',
                'recommendation-card'
              );
            } else {
              recommendationWrapper.classList.add('hidden');
            }

            if (response.data.gifts) {
              updateCartSlider(
                response.data.gifts,
                giftsWrapper,
                giftsSlider,
                undefined,
                'gifts-swiper',
                'gifts-card',
                true
              );
            } else {
              giftsWrapper.classList.add('hidden');
            }

            if (response.data.additional) {
              updateAdditionalItems(
                response.data.additional,
                response.data.cartItems,
              );
            } else {
              additionalProductsWrapper.classList.add('hidden');
            }

            const currentPromo = response.data.promos.find(
              (item) => item.data.code === value,
            );

            if (currentPromo) {
              if (promocodeDescription) {
                if (!promocodeDescription.classList.contains('visible')) {
                  promocodeDescription.classList.add('visible');
                }

                if (!promoErrorText.classList.contains('visible')) {
                  promoErrorText.classList.add('visible');
                }

                const promoDescriptionText = currentPromo.description || currentPromo.name;

                if (currentPromo.active) {
                  promocodeInputWrapper.classList.add('valid');
                  promocodeInputWrapper.classList.remove('error');
                  promocodeDescription.textContent = `Вы выполнили условия акции: ${promoDescriptionText}`;

                  if (promoErrorText) {
                    promoErrorText.classList.add('green-color');
                    promoErrorText.textContent = 'Условия выполнены';
                  }

                  if (placeholder) {
                    placeholder.textContent = 'Промокод активен';
                  }
                } else {
                  promocodeInputWrapper.classList.remove('valid');
                  promocodeInputWrapper.classList.add('error');
                  promocodeDescription.textContent = `Вы не выполнили условия акции: ${promoDescriptionText}`;

                  if (promoErrorText) {
                    promoErrorText.classList.remove('green-color');
                    promoErrorText.textContent = 'Условия не выполнены';
                  }

                  if (placeholder) {
                    placeholder.textContent = 'Промокод неактивен';
                  }
                }
              }
            }
          } else {
            promocodeError.classList.add('visible');

            if (submitButton) {
              const { discount, total } = submitButton.dataset;

              submitButton.classList.remove('disabled');
              submitButton.innerHTML = `Оформить за <span data-discount="${discount}">${total}</span> ₽`;
            }

            if (promocodeSubmitBtn) {
              promocodeSubmitBtn.removeAttribute('disabled');
              promocodeSubmitBtn.value = 'Применить';
            }
          }
        }
      }
    });
  }

  if (promoApplyWithProducts) {
    promoApplyWithProducts.addEventListener('click', async (e) => {
      e.preventDefault();

      const parentElement = promoApplyWithProducts.closest(
        '.promotion-products',
      );
      const { number } = promoApplyWithProducts.dataset;

      if (parentElement) {
        const ids = [];

        const checkedProducts = parentElement.querySelectorAll(
          '.input-button:checked',
        );

        if (checkedProducts) {
          [].forEach.call(checkedProducts, (product) =>
            ids.push({ id: product.value, quantity: 1 }),
          );

          const body = {
            products: JSON.stringify(ids),
          };

          promoApplyWithProducts.textContent = 'Загрузка...';
          promoApplyWithProducts.setAttribute('disabled', 'disabled');

          if (submitButton) {
            submitButton.classList.add('disabled');
            submitButton.innerHTML = 'Загрузка...';
          }

          const response = await postData("/cart", body);

          if (response) {
            if (response.statusCode === 200) {
              const promoBody = {
                promo: number,
              };

              postCartPromo(promoBody);
            } else {
              promoApplyWithProducts.textContent = 'Далее';
              promoApplyWithProducts.removeAttribute('disabled');

              if (submitButton) {
                const { discount, total } = submitButton.dataset;

                submitButton.classList.remove('disabled');
                submitButton.innerHTML = `Оформить за <span data-discount="${discount}">${total}</span> ₽`;
              }
            }
          }
        }
      }
    });
  }

  if (promoCancelWithProductsBtn) {
    promoCancelWithProductsBtn.addEventListener('click', (e) => {
      e.preventDefault();

      if (promoSubmitWrapper) {
        promoSubmitWrapper.classList.remove('hidden');
      }

      if (promoCancelWithProductsBtn) {
        promoCancelWithProductsBtn.classList.remove('visible');
      }

      if (promotionProducts) {
        promotionProducts.classList.remove('visible');
      }

      if (promotionProductsList) {
        promotionProductsList.innerHTML = '';
      }

      if (promocodeInputWrapper) {
        promocodeInputWrapper.classList.remove('error');
      }

      if (promocodeDescription) {
        promocodeDescription.classList.remove('visible');
        promocodeDescription.textContent = '';
      }

      if (promoErrorText) {
        promoErrorText.classList.remove('visible');
        promoErrorText.textContent = '';
      }
    });
  }
});
